/* Ombrance — atelier-wall.js : « Voir mon œuvre sur un mur » (<atelier-wall>). La création est posée en CSS dans nos
   intérieurs (assets atelier-room-*), à l'échelle approximative du format choisi : chaque décor est calibré par la
   largeur réelle du mur visible (cm) et le point d'accroche (centre, bas de l'œuvre). Aucun envoi, aucune génération. */

(() => {
  const A = window.OmbranceAtelier;
  if (!A || customElements.get('atelier-wall')) return;

  const DEFAULT_SIZES = {
    portrait: [[30, 40], [50, 70], [70, 100]],
    square: [[50, 50], [70, 70]],
    landscape: [[40, 30], [70, 50], [100, 70]]
  };

  class AtelierWall extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.dialog = this.querySelector('dialog');
      this.refs = {};
      this.querySelectorAll('[data-ref]').forEach((el) => { this.refs[el.dataset.ref] = el; });
      this.rooms = Array.isArray(A.config.rooms) ? A.config.rooms : [];
      this.room = 0;
      this.size = 0;
      document.addEventListener('atelier:wall', (e) => this.open(e.detail || {}));
      this.refs['wall-rooms'].addEventListener('change', (e) => { this.room = Number(e.target.value); this.render(); });
      this.refs['wall-sizes'].addEventListener('change', (e) => { this.size = Number(e.target.value); this.render(); });
    }

    open({ artwork, sizes, trigger }) {
      if (!artwork || !this.rooms.length) return;
      const aspect = artwork.width && artwork.height
        ? (Math.abs(artwork.width / artwork.height - 1) < 0.05 ? 'square' : artwork.width > artwork.height ? 'landscape' : 'portrait')
        : (artwork.aspect || 'portrait');
      const landscape = aspect === 'landscape';
      const list = (sizes && sizes.length ? sizes : DEFAULT_SIZES[aspect].map(([w, h]) => ({ label: `${w} × ${h} cm`, w, h })))
        .map((s) => {
          const long = Math.max(s.w, s.h);
          const short = Math.min(s.w, s.h);
          const w = aspect === 'square' ? s.w : landscape ? long : short;
          const h = aspect === 'square' ? s.h : landscape ? short : long;
          return { label: s.label, w, h };
        });
      this.sizes = list;
      this.size = Math.min(1, list.length - 1);
      this.artwork = artwork;
      const img = this.refs['wall-img'];
      img.src = A.sized(artwork.previewUrl, 720);
      img.alt = '';
      this.renderChoices(this.refs['wall-rooms'], this.rooms.map((r) => r.label), this.room, 'atelier-wall-room');
      this.renderChoices(this.refs['wall-sizes'], list.map((s) => s.label), this.size, 'atelier-wall-size');
      this.render();
      A.openDialog(this.dialog, trigger);
    }

    renderChoices(box, labels, current, name) {
      box.replaceChildren();
      labels.forEach((text, i) => {
        const label = document.createElement('label');
        label.className = 'opt';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = name;
        input.value = String(i);
        input.checked = i === current;
        const span = document.createElement('span');
        span.textContent = text;
        label.append(input, span);
        box.appendChild(label);
      });
    }

    /* Changement de pièce ou de format : la position et la taille passent par des transitions CSS (atelier.css) */
    render() {
      const room = this.rooms[this.room];
      const size = this.sizes[this.size];
      if (!room || !size) return;
      const bg = this.refs['wall-bg'];
      bg.srcset = `${room.srcSmall} 750w, ${room.src} 1200w`;
      bg.sizes = '(min-width: 990px) 56rem, 100vw';
      bg.src = room.src;
      const art = this.refs['wall-art'];
      art.style.setProperty('--cx', `${room.cx}%`);
      art.style.setProperty('--by', `${room.by}%`);
      art.style.setProperty('--w', `${(size.w / room.cmWidth) * 100}%`);
      art.style.setProperty('--ratio', `${size.w} / ${size.h}`);
    }
  }

  customElements.define('atelier-wall', AtelierWall);
})();
